import { render, staticRenderFns } from "./ScanView.vue?vue&type=template&id=f224665c&"
import script from "./ScanView.vue?vue&type=script&lang=js&"
export * from "./ScanView.vue?vue&type=script&lang=js&"
import style0 from "./ScanView.vue?vue&type=style&index=0&id=f224665c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports